import { Component, OnInit, ViewChild } from "@angular/core";

import { Customer } from "../models/customer";
import { CustomerService } from "../services/customer.service";
import { Router, ActivatedRoute } from "@angular/router";
import { WorkorderService } from "../services/workorder.service";
import { MatDialog } from "@angular/material/dialog";
import { EnrollmentService } from "../services/enrollment.service";
import Swal from "sweetalert2";
import { MatAccordion } from "@angular/material/expansion";
import { CanceldeactivateDialogComponent } from "../util/canceldeactivate-dialog/canceldeactivate-dialog.component";
import { UploadDialogComponent } from "../util/upload-dialog/upload-dialog.component";
import { ViewdocsDialogComponent } from "../util/viewdocs-dialog/viewdocs-dialog.component";
import { WorkorderExceptionsComponent } from "../workorder-exceptions/workorder-exceptions.component";
import { UtilityService } from "../services/utility.service";
import { CancelscheduleDialogComponent } from "../util/cancelschedule-dialog/cancelschedule-dialog.component";
import { DataTransferService } from "../services/data-transfer.service";
import { WorkorderStatusDialogComponent } from "../util/workorder-status-dialog/workorder-status-dialog.component";
import { LocationsearchService } from "../services/locationsearch.service";
import { Interaction } from "src/app/models/interaction";
import { Subscription, interval, iif, forkJoin } from "rxjs";
import { InteractionsService } from "src/app/services/interactions.service";
import { MatCheckbox } from "@angular/material/checkbox";
import { OnholdreasonDialogComponent } from "../util/onholdreason-dialog/onholdreason-dialog.component";
import { NgxSpinnerService } from "ngx-spinner";
import moment from "moment";
import { Subject } from "rxjs";
import { ComparisonScreenDialogComponent } from "../util/comparison-screen-dialog/comparison-screen-dialog.component";
import { HomeAuditMeasureComponent } from "../home-audit-measure/home-audit-measure.component";
import { MeasuresComponent } from "../measures/measures.component";
import { UploadExcelComponent } from "../distributor/dialogs/upload-excel/upload-excel.component";
import { QhecReport } from "./qhec-report";
import { DomInitialReport } from "./dom-initial-report";
import { DomComprehensiveReport } from "./dom-comprehensive-report";
import { UserService } from "../services/user.service";
import { HttpClient } from '@angular/common/http';
import { WorkorderAttribute, WorkorderSectionInfo } from "../models/workorder-attribute";

export interface Dropdown {
  id: string;
  value: string;
}
export class SectionArray {
  sectionId: any;
  rowId: any;
}

interface WorkOrder {
  workOrderId: string;
  group: string;
  subgroup: string;
  subgroup1: string;
  displayLinkStyle: boolean;
  stage?: string
}

interface QaWorkOrder extends WorkOrder {
  auditor: string;
  dateTime: string;
  score: number;
  status: string;
}

@Component({
  selector: "app-dr-workorder",
  templateUrl: "./workorder-getsave.component.html",
  styleUrls: ["./workorder-getsave.component.scss"],
})
export class WorkorderGetSaveComponent implements OnInit {
  sectionName: string;
  isDisabled: boolean;
  loggedinuserrole: any = this.utilityService.currentUtility.LoggedInUserRole;
  office_id: any = this.utilityService.currentUtility.OfficeId;
  response: any = [];
  loadDialog: any = true;
  loadTable: any = true;
  loadWorkorder: any = true;
  workorderID: any = this.workorderService.currentWorkorderID;
  enrollmentID: any = this.enrollmentService.currentEnrollmentID;
  SectionId1 = "ManufModelData";
  expandedItem: any;
  sectionEdited: any;
  ifExpanded = true;
  sectionObj: SectionArray[] = [];
  newApplianceObj: any;
  dynamicMenuList: any = [];
  group: any;
  subgroup: any;
  subGroup1: any;
  showAddInteractions = false;
  showAddMeasures = false;
  compassJobId: any;
  compassEnabled: any;
  user: any;
  count = 0;
  nonMatchingCESections: any[] = [];
  multiSectionTitle: string = "Workorder Multi Sections";

  @ViewChild("Woaccordion", { static: false }) Woaccordion: MatAccordion;

  //add interaction
  ifSave: boolean;
  types: Dropdown[] = [];
  marketing: Dropdown[] = [];
  whys: Dropdown[] = [];
  reasons: Dropdown[] = [];
  selectedTypeCode: any;
  selectedReason: any;
  selectedWhy: any;
  selectedMarketing: any;
  isCompleteChecked: boolean;
  notesInput: any;
  timerMinutes: any;
  timerSeconds: any;
  customerId: any;
  officeId: any;
  programSponsorId: any;
  savedInteraction: Interaction = new Interaction();
  startTime = new Date();
  timerInterval: Subscription;
  timersource = interval(1000);
  timer = "0:00";
  statusMessage: string;
  checkIfComplete: boolean = false;
  className: any;
  adding = false;
  disableMainSave = false;
  psegdisable = "No";
  tabularLength: any;
  tabularLengthDelete: any;
  @ViewChild("completeCheckbox", { static: true })
  private completeCheckbox: MatCheckbox;

  //---------Measures-----------
  lineItemId: any;
  measureResponse: any = [];
  measuresLength = 0;
  selectedMeasureType: any;
  term: any;
  measureData: any = [];
  filterNewFixture: any = [];
  existingFixtureArray: any = [];
  esmodelArray: any = [];
  manufacturerArray: any = [];
  energyStarModelArray: any = [];

  manufacturerhvacArray: any = [];
  modelhvacArray: any = [];
  snuggProMeasuresSection: any = [];
  //---------Date-------------------
  thresHoldValue: any;
  minDateToFinish = new Subject<string>();
  inputReadOnly = true;
  //---Auto save----
  isChildCompoCalled = false;
  parentWorkOrder: WorkOrder;
  incentiveWorkOrders: WorkOrder[] = [];
  qaTableDataSource: QaWorkOrder[] = [];
  qaDisplayedColumns = ['workOrderId', 'auditor', 'dateTime', 'score', 'status'];
  isCustomUiChange: boolean = false;

  @ViewChild(HomeAuditMeasureComponent) homeAuditComponent;
  @ViewChild(MeasuresComponent) measurComponent;

  constructor(
    private customerService: CustomerService,
    private router: Router,
    private workorderService: WorkorderService,
    private enrollmentService: EnrollmentService,
    private utilityService: UtilityService,
    private dialog: MatDialog,
    private locationSearchService: LocationsearchService,
    private dataTransfer: DataTransferService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private interactionService: InteractionsService,
    private userService: UserService,
    private http: HttpClient
  ) {
    this.className = localStorage.getItem("themeName");
    this.isCustomUiChange = this.userService.IsCustomUiChange;
  }

  ngOnInit() {
    this.initfunc();
    this.user = this.userService.dbBBCSId ? this.userService.dbBBCSId : this.utilityService.currentUtility.BBCSUserId;
    this.compassEnabled = localStorage.getItem("compassEnabled");
    this.compassJobId = localStorage.getItem("compassJobId");
    //to calculate the number of records in Manufactorers and Models
    this.workorderService.addPsgAppliance(
      this.workorderID,
      this.SectionId1,
      this.subgroup,
      this.subGroup1
    ).subscribe((res) => {
      this.response.SectionInfo?.forEach((element) => {
        if (this.SectionId1 == element.SectionId) {
          this.tabularLengthDelete = element.Tabular.length;
          element.Tabular.push(res);
        }
      });
    });
  }

  ngAfterViewInit() {
    this.loadDRWorkorder();
    this.loadDynamicMenu();
  }

  initfunc() {
    this.dataTransfer.myMethod(true);
    this.expandedItem = null;
    this.loadTable = false;
    this.locationSearchService.personcompany = null;
    this.locationSearchService.schdate = null;
    this.locationSearchService.scheduledate = null;
    this.locationSearchService.grid = null;
    this.locationSearchService.workorderID = null;

    this.setWorkOrderParametersFromRoute();
  }

  setWorkOrderParametersFromRoute() {
    this.workorderID = this.route.snapshot.paramMap.get("workorderID");
    this.group = this.route.snapshot.paramMap.get("group");
    this.subgroup = this.route.snapshot.paramMap.get("subgroup");
    this.subGroup1 = this.route.snapshot.paramMap.get("subgroup1");
  }

  /**
    * Separate sections into multi-section and non-matching 
    * sections based on IsMultiSection property.
  */
  getStandardSection() {
    if (this.response?.MultiSection === "Enable") {
      this.nonMatchingCESections = [];
      this.response.SectionInfo.filter(element => {
        if (element?.IsMultiSection === 1)
          this.nonMatchingCESections.push(element);
      });
    }
  }

  /**
   * Toggle the selection of a card in the multi-section accordion.
   * @param card - The card to be toggled.
   * @param event - The click event.
   */
  toggleCardSelection(card: any, event: Event): void {
    event.stopPropagation();
    const existingCardIndex = this.response.SectionInfo.findIndex(section => section.SectionName === card.SectionName);

    if (existingCardIndex !== -1) {
      this.response.SectionInfo = this.response.SectionInfo.map(res => {
        if (card.SectionName === res.SectionName) {
          res.IsMultiSection = res.IsMultiSection === 1 ? 0 : 1;
        }
        return res;
      });
    }
  }

  /**
   * Check if a card is selected in the multi-section accordion.
   * @param card - The card to check.
   * @returns boolean - True if the card is selected, false otherwise.
   */
  isCardSelected(card: any): boolean {
    const section = this.response.SectionInfo.find(section => section.SectionName === card.SectionName);
    return section ? section.IsMultiSection === 0 : false;
  }


  /** Converts a string to title case
   * @param str The input string 
   * @returns The transformed string in title case
   */
  toTitleCase(str: string): string {
    return str.replace(/\w\S*/g, (txt) => {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  isLabelTooLong(str: string): boolean {
    return str?.length > 24;
  }

  loadDynamicMenu() {
    this.workorderID = this.workorderService.currentWorkorderID;
    this.workorderService.loadDynamicMenu(this.workorderID).subscribe((res) => {
      this.dynamicMenuList = res.MenuList;
    });
  }

  chooseRoute(menuId, lineItemID = null, menuName) {
    if (menuId == "UploadImage") {
      this.uploadDocs(lineItemID);
    } else if (menuId == "ViewImage") {
      this.viewDocs(lineItemID);
    } else if (menuId == "Deactivate") {
      this.actionWorkorder("Deactivate");
    } else if (menuId == "Cancel") {
      this.actionWorkorder("Cancel");
    } else if (menuId == "Schedule") {
      if (
        this.group != null &&
        this.group != undefined &&
        this.subgroup != null &&
        this.subgroup != undefined
      ) {
        this.workorderService.workorderStatusCode = "schedule";
        this.router.navigate([
          "scheduling",
          this.group,
          this.subgroup,
          this.workorderID,
          "schedule",
        ]);
      }
    } else if (menuId == "Reschedule") {
      if (
        this.group != null &&
        this.group != undefined &&
        this.subgroup != null &&
        this.subgroup != undefined
      ) {
        this.workorderService.workorderStatusCode = "reschedule";
        this.router.navigate([
          "scheduling",
          this.group,
          this.subgroup,
          this.workorderID,
          "reschedule",
        ]);
      }
    } else if (menuId == "CancelAppointment") {
      let className = localStorage.getItem("themeName");
      const dialogRef = this.dialog.open(CancelscheduleDialogComponent, {
        data: {
          workorderID: this.workorderID,
        },
        panelClass: className,
      });
      dialogRef.afterClosed().subscribe((res) => {
        this.loadDRWorkorder();
        this.loadDynamicMenu();
        this.closeMeasureEditor();
      });
    } else if (menuId == "AddInspWorkorder") {
      this.addInspectionWorkorder();
    } else if (menuId == "CustomAction") {
      this.addCustomWorkorder(this.workorderID, menuName);
    } else if (menuId == "Complete") {
      Swal.fire({
        title: "Are you sure you want to complete the workorder?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          this.completeWorkorder();
          this.closeMeasureEditor();
        }
      });
    } else if (menuId == "ReturnToDE") {
      Swal.fire({
        title: "Are you sure you want to return workorder to data entry?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          this.returnDeToWorkorder();
          this.closeMeasureEditor();
        }
      });
    } else if (menuId == "OffHold") {
      Swal.fire({
        title: "Are you sure you want to return workorder to Off Hold?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          this.spinner.show();
          this.returnOffHoldWorkorder();
          this.closeMeasureEditor();
        }
      });
    } else if (menuId == "Assign") {
      Swal.fire({
        title: "Are you sure you want to return workorder to Assigned?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          this.spinner.show();
          this.returnAssignWorkorder();
          this.closeMeasureEditor();
        }
      });
    } else if (menuId == "OnHold") {
      // Swal.fire({
      //   title: 'Are you sure you want to return workorder to On Hold?',
      //   text: "You won't be able to revert this!",
      //   icon: 'warning',
      //   showCancelButton: true,
      //   confirmButtonColor: '#3085d6',
      //   cancelButtonColor: '#d33',
      //   confirmButtonText: 'Yes!'
      // }).then(() => {
      //   this.goToOnHoldReasons(this.workorderID);
      // })
      this.goToOnHoldReasons(this.workorderID);
    } else if (menuId == "InstallComplete") {
      Swal.fire({
        title: "Are you sure you want to mark workorder to Install Complete?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          this.spinner.show();
          this.InstallcompleteWorkorder();
          this.closeMeasureEditor();
        }
      });
    } else if (menuId == "Approve") {
      Swal.fire({
        title: "Are you sure you want to mark workorder to " + (this.response?.DistributorApproveButtonName ? "next status?" : "Ready for Rebate?"),
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          this.spinner.show();
          this.workorderService
            .changeWorkorderStatus(this.workorderID, this.subgroup)
            .subscribe((res) => {
              if (res?.Action) {
                Swal.fire(res.Message);
              } else {
                this.spinner.hide();
                this.loadDRWorkorder();
                this.closeMeasureEditor();
              }
            });
        }
      });
    } else if (menuId == "Reject") {
      this.actionWorkorder("Reject");
    } else if (menuId == "ImportFromSnuggPro") {
      this.getDataFromSnuggPro();
    } else if (menuId == "CreateSnuggProJob") {
      const snuggproId = this.response.SectionInfo.find(x => x.SectionId === 'CustAssessment')
        .DetailedInfo[0].Attributes.find(x => x.AttributeId === 'externalgroup_fee6').SelectedValue;
      if (!snuggproId) {
        this.createSnuggProJob();
      } else {
        Swal.fire({
          text: "Snuggpro Job_id already exists",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    }
    else if (menuId == "ResendAEG") {
      Swal.fire({
        title: "Are you sure you want to mark this workorder to Resend to AEG?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          this.spinner.show();
          this.resendToAEGWorkorder();
          //this.closeMeasureEditor();
        }
      });
    }
  }

  closeMeasureEditor() {
    this.measuresLength = 0;
    if (this.subGroup1 == "HOMEAUDIT") {
      this.homeAuditComponent?.addMeasureClose();
    } else {
      this.measurComponent?.addMeasureClose();
    }
  }

  getDataFromSnuggPro() {
    const snuggproJobId = this.response.SectionInfo.find(x => x.SectionId === 'CustAssessment')
      .DetailedInfo[0].Attributes.find(x => x.AttributeId === 'externalgroup_fee6').SelectedValue;
    if (!snuggproJobId) {
      Swal.fire({
        text: "SnuggPro job ID Missing",
        icon: "error",
        confirmButtonText: "OK",
      });
    } else {
      this.spinner.show();
      forkJoin([this.workorderService
        .addMeasures(
          this.workorderID,
          "addMeasure",
          localStorage.getItem("subGroup"),
          "ALL",
          "ALL",
          localStorage.getItem("subGroup1")
        ),
      this.workorderService.importFromSnuggpro(snuggproJobId)
      ]).subscribe(
        ([
          measureAttributes,
          snuggproData
        ]) => {
          if (snuggproData && measureAttributes) {

            const customerAttributes = this.response.SectionInfo.find(section =>
              section.SectionId === 'CUSTDATA'
            )?.DetailedInfo[0]?.Attributes;

            const assQuestionAttributes = this.response.SectionInfo.find(section =>
              section.SectionId === 'CustAssessment'
            )?.DetailedInfo[0]?.Attributes;

            const testResultsAttributes = this.response.SectionInfo.find(section =>
              section.SectionId === 'MEASTEST'
            )?.DetailedInfo[0]?.Attributes;

            customerAttributes?.forEach(c => {
              if (c.AttributeId in snuggproData) {
                if (!c.Values) {
                  c.SelectedValue = snuggproData[c.AttributeId];
                } else {
                  c.SelectedValue = c.Values.find(x => x.Value === snuggproData[c.AttributeId])?.Id;
                }
              }
            });

            assQuestionAttributes?.forEach(a => {
              if (a.AttributeId in snuggproData) {
                if (!a.Values) {
                  a.SelectedValue = snuggproData[a.AttributeId];
                } else {
                  // Todo need to come up with a common lookup value 
                  // const id = a.Values.find(x => x.Value === snuggproData[a.AttributeId])?.Id;
                  // a.SelectedValue = id ? id : a.Values[0].Id;
                }
              }
            });

            testResultsAttributes?.forEach(a => {
              if (a.AttributeId in snuggproData) {
                if (!a.Values) {
                  a.SelectedValue = snuggproData[a.AttributeId];
                } else {
                  // Todo need to come up with a common lookup value 
                  // const id = a.Values.find(x => x.Value === snuggproData[a.AttributeId])?.Id;
                  // a.SelectedValue = id ? id : a.Values[0].Id;
                }
              }
            });

            this.addMeasuresFromSnuggpro(measureAttributes, snuggproData);
            this.onSave(this.response);
            // this.spinner.hide();           
          }
        }
      );
    }
  }

  createSnuggProJob() {
    this.spinner.show();

    // Prepare Request Data
    const reqData = {} as any;
    const custInfoAttributes = this.response.SectionInfo.find(x => x.SectionId === 'CUSTDATA').DetailedInfo[0].Attributes;
    reqData.accountId = +custInfoAttributes.find(x => x.AttributeId === 'AccNumber').SelectedValue;
    const fullName = custInfoAttributes.find(x => x.AttributeId === 'CustName').SelectedValue;
    const parts = fullName.trim().split(' ');
    if (parts.length > 1) {
      reqData.firstName = parts[0];
      reqData.lastName = parts[parts.length - 1];
    } else {
      reqData.firstName = fullName;
      reqData.lastName = '';
    }
    reqData.address1 = custInfoAttributes.find(x => x.AttributeId === 'CustAddr').SelectedValue.trim();
    reqData.city = custInfoAttributes.find(x => x.AttributeId === 'City').SelectedValue;
    reqData.state = custInfoAttributes.find(x => x.AttributeId === 'State').SelectedValue;
    reqData.zip = custInfoAttributes.find(x => x.AttributeId === 'Zip').SelectedValue;
    reqData.jobType = '1';
    reqData.stageId = '1';

    this.workorderService.createSnuggProJob(this.response.WorkorderId, reqData).subscribe({
      next: (data) => {
        this.spinner.hide();
        this.response.SectionInfo.find(x => x.SectionId === 'CustAssessment')
          .DetailedInfo[0].Attributes.find(x => x.AttributeId === 'externalgroup_fee6').SelectedValue = data.id;
        Swal.fire({
          text: "Successfully created SnuggPro job",
          icon: "success",
          confirmButtonText: "OK",
        });
      },
      error: (err) => {
        this.spinner.hide();
        Swal.fire({
          text: "Error creating SnuggPro job : " + err,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    });
  }

  addMeasuresFromSnuggpro(measureTemplate: any, snuggproData: any) {
    const snuggproMeasures: any[] = [];
    let lineitemId = measureTemplate?.DetailedInfo[0]?.Attributes?.find(a => a.AttributeId === 'lineitem_id_fee6');
    if (lineitemId) {
      lineitemId.SelectedValue = null;
    }
    snuggproData?.measures?.forEach(m => {
      const copiedTemplate = JSON.parse(JSON.stringify(measureTemplate));

      copiedTemplate?.DetailedInfo[0]?.Attributes?.forEach(mt => {
        if (mt.Name === 'Measure') {
          mt.SelectedValue = mt.Values.find(v => v.Value === m.Measure) ? mt.Values.find(v => v.Value === m.Measure).Id : 'FEE6HAU019';
        } else if (mt.Name === 'Quantity') {
          mt.SelectedValue = m.Quantity;
        } else if (mt.Name === 'Measure Category') {
          mt.SelectedValue = mt.Values.find(v => v.Value === m.Category)?.Id;
        } else if (mt.Name === 'Installed Location') {
          mt.SelectedValue = mt.Values.find(v => v.Value === m.InstalledLocation)?.Id;
        } else if (mt.Name === 'Energy Saving(kWh)') {
          mt.SelectedValue = m.EnergySavingsKWh;
        } else if (mt.Name === 'Cost($)') {
          mt.SelectedValue = m.Cost;
        }
      });
      snuggproMeasures.push(copiedTemplate);
    });

    this.snuggProMeasuresSection = snuggproMeasures;
  }

  InstallcompleteWorkorder() {
    this.workorderService
      .InstallcompleteWorkorder(this.workorderID)
      .subscribe((res: any) => {
        if (res?.Action == 0) {
          this.spinner.hide();
          Swal.fire({
            text: "Workorder Marked Install Complete!",
            icon: "success",
            confirmButtonText: "OK",
          }).then((result) => {
            this.loadDRWorkorder();
            this.loadDynamicMenu();
          });
        } else {
          this.spinner.hide();
          Swal.fire({
            text: res.Message,
            icon: "error",
            confirmButtonText: "OK",
          }).then((result) => {
            this.loadDRWorkorder();
            this.loadDynamicMenu();
          });
        }
      });
  }

  goToOnHoldReasons(workorderId) {
    let deactivateObj = {
      WorkorderID: workorderId,
      StatusCode: 850,
    };
    let className = localStorage.getItem("themeName");
    const dialogRef = this.dialog.open(OnholdreasonDialogComponent, {
      data: {
        dataKey: deactivateObj,
      },
      panelClass: className,
    });
    dialogRef.afterClosed().subscribe((res) => {
      this.loadDRWorkorder();
      this.loadDynamicMenu();
      this.closeMeasureEditor();
    });
  }

  onexception(resworkorder) {
    let className = localStorage.getItem("themeName");
    const dialogRefs = this.dialog.open(WorkorderExceptionsComponent, {
      width: "100%",
      height: "80%",
      data: {
        workorder: resworkorder,
        roles: this.loggedinuserrole,
        office: this.office_id,
        panelClass: className,
        loadDR: this.loadDRWorkorder,
        loadMenu: this.loadDynamicMenu,
      },
    });
    dialogRefs.afterClosed().subscribe((res: boolean) => {
      if (res) {
        this.loadDRWorkorder();
        this.loadDynamicMenu();
      }
    });
  }

  returnOffHoldWorkorder() {
    this.workorderService
      .returnOffholdWorkorderService(this.workorderID)
      .subscribe((res: any) => {
        //Compass integration -start
        if (res?.Action == 0 && this.compassEnabled == "1") {
          this.workorderService
            .getCompassOffHold(this.workorderID, this.user, this.compassJobId)
            .subscribe((res1) => {
              if (res1.Action) {
                this.spinner.hide();
                Swal.fire({
                  text: " Offhold  not successful. Reason: " + res1.Message,
                  icon: "error",
                  confirmButtonText: "OK",
                }).then((result) => {
                  if (result.value) {
                    this.dialog.closeAll();
                  }
                });
              } else {
                this.spinner.hide();
                Swal.fire({
                  text: "Workorder returned to Off Hold",
                  icon: "success",
                  confirmButtonText: "OK",
                }).then((result) => {
                  if (result.value) {
                    //this.dialog.closeAll();
                    this.loadDRWorkorder();
                    this.loadDynamicMenu();
                  }
                });
              }
            });
        }
        if (res?.Action == 0 && this.compassEnabled == "0") {
          this.spinner.hide();
          Swal.fire({
            text: "Workorder returned to Off Hold successfully",
            icon: "success",
            confirmButtonText: "OK",
          }).then((result) => {
            if (result.value) {
              //this.dialog.closeAll();
              this.loadDRWorkorder();
              this.loadDynamicMenu();
            }
          });
        }

        if (res?.Action == 0 && this.compassEnabled == "undefined") {
          this.spinner.hide();
          Swal.fire({
            text: "Workorder returned to Off Hold successfully",
            icon: "success",
            confirmButtonText: "OK",
          }).then((result) => {
            if (result.value) {
              //this.dialog.closeAll();
              this.loadDRWorkorder();
              this.loadDynamicMenu();
            }
          });
        }
        ////Compass integration -end
        if (res?.Action != "0" && this.compassEnabled == "0") {
          this.spinner.hide();
          Swal.fire({
            text: res.Message,
            icon: "error",
            confirmButtonText: "OK",
          }).then((result) => {
            if (result.value) {
              this.loadDRWorkorder();
              this.loadDynamicMenu();
            }
          });
        }
      });
  }

  returnAssignWorkorder() {
    this.workorderService
      .returnAssignWorkorderService(this.workorderID)
      .subscribe((res: any) => {
        if (res.Action == 0) {
          this.spinner.hide();
          Swal.fire({
            text: "Workorder returned to Assigned",
            icon: "success",
            confirmButtonText: "OK",
          }).then((result) => {
            if (result.value) {
              this.loadDRWorkorder();
              this.loadDynamicMenu();
            }
          });
        } else {
          this.spinner.hide();
          Swal.fire({
            text: res.Message,
            icon: "error",
            confirmButtonText: "OK",
          }).then((result) => {
            if (result.value) {
              this.loadDRWorkorder();
              this.loadDynamicMenu();
            }
          });
        }
      });
  }

  returnDeToWorkorder() {
    this.workorderService
      .returnToDEWorkorderService(this.workorderID, "")
      .subscribe((res: any) => {
        if (res?.Action == 0) {
          this.spinner.hide();
          Swal.fire({
            text: "Workorder returned to data entry",
            icon: "success",
            confirmButtonText: "OK",
          }).then((result) => {
            if (result.value) {
              this.loadDRWorkorder();
              this.loadDynamicMenu();
            }
          });
        } else {
          this.spinner.hide();
          Swal.fire({
            text: res.Message,
            icon: "error",
            confirmButtonText: "OK",
          }).then((result) => {
            if (result.value) {
              this.loadDRWorkorder();
              this.loadDynamicMenu();
            }
          });
        }
      });
  }

  resendToAEGWorkorder() {
    this.workorderService
      .resendToAEGWorkorderService(this.workorderID)
      .subscribe((res: any) => {
        if (res?.Action == 0) {
          this.spinner.hide();
          Swal.fire({
            text: "Workorder resend to AEG",
            icon: "success",
            confirmButtonText: "OK",
          }).then((result) => {
            if (result.value) {
              this.loadDRWorkorder();
            }
          });
        } else {
          this.spinner.hide();
          Swal.fire({
            text: res.Message,
            icon: "error",
            confirmButtonText: "OK",
          })
        }
      });
  }

  completeWorkorder() {
    this.workorderService
      .completeWorkorder(this.workorderID)
      .subscribe((res: any) => {
        if (res?.Action == 0) {
          this.spinner.hide();
          Swal.fire({
            text: "Workorder Marked complete!",
            icon: "success",
            confirmButtonText: "OK",
          }).then((result) => {
            if (result.value) {
              this.loadDRWorkorder();
              this.loadDynamicMenu();
            }
          });
        } else {
          this.spinner.hide();
          Swal.fire({
            text: res.Message,
            icon: "error",
            confirmButtonText: "OK",
          }).then((result) => {
            if (result.value) {
              this.loadDRWorkorder();
              this.loadDynamicMenu();
              this.closeMeasureEditor();
            }
          });
        }
      });
  }

  oninitialize(selectvalue: any, attribute: any, editable: any) {
    if (attribute == "REFOWN1") {
      if (selectvalue == "2" && editable == "Yes") {
        this.psegdisable = "Yes";
      } else if (selectvalue == "1" || editable != "Yes") {
        this.psegdisable = "No";
      }
    }
  }

  dataChanged_customize($event, sectionId, rowId, attribute: any) {
    if (attribute == "REFOWN1") {
      this.onChangeDropDown($event);
    }
    this.sectionEdited = true;
    this.sectionObj.push({ sectionId: sectionId, rowId: rowId });
  }

  dataChanged($event, sectionId, rowId) {
    this.sectionEdited = true;
    this.sectionObj.push({ sectionId: sectionId, rowId: rowId });
  }

  isMultiSelectAttribute(attribute: Pick<WorkorderAttribute, 'DataType' | 'Name'>): boolean {
    return attribute?.DataType === 'List' &&
      attribute?.Name?.replace(/\s+/g, ' ').trim().toLowerCase() ===
      'exhaust appliances on during test(check all that apply)';
  }

  private toMultiSelectValues(selectedValue: WorkorderAttribute['SelectedValue']): string[] {
    if (Array.isArray(selectedValue)) {
      return selectedValue;
    }

    if (selectedValue) {
      return selectedValue.toString().split(',').map((item: string) => item.trim()).filter(Boolean);
    }

    return [];
  }

  private serializeMultiSelectAttributes(sectionContainer: { SectionInfo: WorkorderSectionInfo[] }): void {
    sectionContainer.SectionInfo.forEach((section) => {
      section.DetailedInfo?.forEach((detail) => {
        detail.Attributes.forEach((attribute) => {
          if (this.isMultiSelectAttribute(attribute) && Array.isArray(attribute.SelectedValue)) {
            attribute.SelectedValue = attribute.SelectedValue.join(',');
          }
        });
      });
    });
  }

  onChangeDropDown(value: any) {
    if (value == "2") {
      this.psegdisable = "Yes";
    } else if (value == "1") {
      this.psegdisable = "No";
    }
  }

  psgDataChanged($event, sectionId, rIndex, cIndex, Name, nIndex) {
    let index = nIndex ? nIndex : rIndex;
    this.response.SectionInfo.forEach((element) => {
      if (sectionId == element.SectionId) {
        element.IsSectionModified = "true";
        element.Tabular[index].showAddMeasures = 1;
        element.Tabular[index].IsLineitemModified = 1;
        element.Tabular[index].Attributes[cIndex]["SelectedValue"] = $event;
        const selValList =
          element.Tabular[index].Attributes[cIndex]["Values"] || [];
      }
    });
  }

  addPSGAppliance(index, SectionId) {
    this.expandedItem = index;
    this.subgroup = localStorage.getItem("subGroup");
    this.subGroup1 = localStorage.getItem("subGroup1");
    this.workorderService
      .addPsgAppliance(
        this.workorderID,
        SectionId,
        this.subgroup,
        this.subGroup1
      )
      .subscribe(
        (res) => {
          this.response.SectionInfo.forEach((element) => {
            if (SectionId == element.SectionId) {
              element.IsSectionModified = "true";
              res["newIndex"] = element.Tabular.length;
              this.tabularLength = element.Tabular.length;
              if (this.tabularLength == 10) {
                Swal.fire({
                  text: "You cannot add more than 10 Manufacturers and Models",
                  icon: "error",
                  confirmButtonText: "OK",
                }).then(() => {
                  this.dialog.closeAll();
                  this.loadDRWorkorder();
                  this.loadDynamicMenu();
                });
              }
              element.Tabular.push(res);
            }
          });
        },
        (err) => { }
      );
  }

  addApplianceInfo(index, SectionId) {
    this.expandedItem = index;
    this.subgroup = localStorage.getItem("subGroup");
    this.subGroup1 = localStorage.getItem("subGroup1");
    if (this.tabularLength > 10) {
      Swal.fire({
        text: "You cannot add more than 10 Manufacturers and Models",
        icon: "error",
        confirmButtonText: "OK",
      }).then(() => {
        this.dialog.closeAll();
        this.loadDRWorkorder();
        this.loadDynamicMenu();
      });
    }
    this.workorderService
      .addApplianceDetails(
        this.workorderID,
        SectionId,
        this.subgroup,
        this.subGroup1
      )
      .subscribe(
        (res) => {
          this.response.SectionInfo.forEach((element) => {
            if (SectionId == element.SectionId) {
              element.IsSectionModified = "true";
              res["newIndex"] = element.Tabular.length;
              if (this.tabularLength == 10) {
                Swal.fire({
                  text: "You cannot add more than 10 Manufacturers and Models",
                  icon: "error",
                  confirmButtonText: "OK",
                }).then(() => {
                  this.dialog.closeAll();
                  this.loadDRWorkorder();
                  this.loadDynamicMenu();
                });
              }
              element.Tabular.push(res);
            }
          });
        },
        (err) => { }
      );
  }

  onDeletePSGAppliance(lineItem, oldIndex, newIndex, sectionId) {
    let index = newIndex ? newIndex : oldIndex;
    this.subgroup = localStorage.getItem("subGroup");
    this.subGroup1 = localStorage.getItem("subGroup1");
    if (lineItem) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result: any) => {
        // if line item is old then call delete API.
        if (result.value) {
          this.workorderService
            .deletePSGRow(this.response.WorkorderId, lineItem, this.subgroup)
            .subscribe(
              (res) => {
                if (!res.Message) {
                  Swal.fire({
                    text: "Successfully Deleted",
                    icon: "success",
                    confirmButtonText: "OK",
                  }).then(() => {
                    this.dialog.closeAll();
                    this.loadDRWorkorder();
                    this.loadDynamicMenu();
                  });
                } else {
                  Swal.fire({
                    text: res.Message,
                    icon: "error",
                    confirmButtonText: "OK",
                  });
                }
              },
              (err) => {
                Swal.fire({
                  text: "Error While Deleting",
                  icon: "error",
                  confirmButtonText: "OK",
                });
              }
            );
        }
      });
    } else {
      // if line item is new delete from the local variable.
      this.response.SectionInfo.forEach((element) => {
        if (sectionId == element.SectionId) {
          element.Tabular.splice(index, 1);
        }
      });
    }
  }

  closeAll() {
    if (this.ifExpanded) {
      this.ifExpanded = false;
      this.Woaccordion.closeAll();
    } else {
      this.Woaccordion.openAll();
      this.ifExpanded = true;
    }
  }

  uploadDocs(lineItemID = null) {
    let className = localStorage.getItem("themeName");
    const dialogRef = this.dialog.open(UploadDialogComponent, {
      data: {
        workOrderID: this.workorderID,
        lineItemID: lineItemID,
      },
      panelClass: className,
      disableClose: true
    });

    if (lineItemID != null) {
      dialogRef.afterClosed().subscribe((res) => {
        this.loadDRWorkorder();
        this.loadDynamicMenu();
        this.closeMeasureEditor();
      });
    }
  }

  viewDocs(lineItemID) {
    let className = localStorage.getItem("themeName");
    this.dialog.open(ViewdocsDialogComponent, {
      data: { workOrderID: this.workorderID, lineItemID: lineItemID, officeId: this.utilityService?.currentUtility?.OfficeId },
      panelClass: className,
      disableClose: true
    });
  }

  loadDRWorkorder() {
    this.enrollmentID = this.enrollmentService?.currentEnrollmentID;
    this.loadWorkorder = true;

    let customerId = "undefined";
    if (this.workorderService?.currentWorkorder != undefined) {
      customerId = this.workorderService?.currentWorkorder?.CustomerId;
    }

    this.workorderService.getBBCSWorkorderDetail(
      this.workorderID,
      this.group,
      this.subgroup,
      customerId,
      this.subGroup1
    ).subscribe({
      next: (res) => {
        this.response = res;

        console.log('workOrderResponse: ' + JSON.stringify(res));

        this.setIncentiveWorkOrders(res);
        this.setParentWorkOrder(res);
        this.setQaWorkOrders(res);

        this.getStandardSection();
        if (this.response.GenerateReport == 1) {
          this.workorderService.getVirtualAuditWOInfo(this.workorderID).subscribe((repInfo) => {
            this.doReport(repInfo);
          });
        }
        this.response["MeasureSectionInfo"] = [];
        const measuredata = localStorage.getItem("mData");
        if (measuredata != null) {
          localStorage.removeItem("mData");
        }

        this.workorderService.currentIAWorkorderID = this.response?.IAWorkorder;
        localStorage.setItem("compassEnabled", this.response.CompassEnabled);
        localStorage.setItem("compassJobId", this.response.CompassJobId);
        localStorage.setItem("subGroup", this.response.SubGroup ?? "ALL");
        localStorage.setItem("subGroup1", this.response.SubGroup1 ?? "ALL");
        localStorage.setItem(
          "programdetailid",
          this.response.ProgramdetailId
        );
        this.loadWorkorder = false;
        this.datepickerWork(res, false);
        this.response?.SectionInfo.forEach((element) => {
          if (element.DetailedInfo) {
            element.DetailedInfo.forEach((dElement) => {
              dElement.Attributes.forEach((aElement) => {
                if (aElement.DataType == 'Bit') {
                  aElement.SelectedValue = (aElement.SelectedValue == true) ? 1 : 0;
                }
                if (this.isMultiSelectAttribute(aElement)) {
                  aElement.SelectedValue = this.toMultiSelectValues(aElement.SelectedValue);
                }
                if (aElement.AttributeId == 'TVFD') {
                  this.thresHoldValue = aElement.SelectedValue;
                }
              });
            });
          }
        });

        if (
          this.response.SubGroup1 == "COMLIGHT" ||
          this.response.SubGroup1 == "PRISCRIP"
        ) {
          this.payeeOnPageLoad();
        }
      },
      error: (err) => {
        console.log(`Error: ${err}`);
      }
    });
  }

  openAddInteraction(customerId, toggleAddInteractions, sectionName, index) {
    this.expandedItem = index;
    this.loadDialog = true;
    this.showAddInteractions =
      toggleAddInteractions == 1 && sectionName == "Interactions";
    this.customerService
      .getCustomerById(customerId)
      .subscribe((cust: Customer[]) => {
        this.getCustomerObj(cust);
        this.onLoad();
      });
  }
  // for unsorted headers
  unsorted() { }

  addAppliance(tile, index) {
    this.expandedItem = index;
    this.workorderService
      .addAppliance(this.workorderID, this.subgroup)
      .subscribe(
        (res) => {
          this.newApplianceObj = res;
          tile.DetailedInfo.push(this.newApplianceObj.DetailedInfo);
        },
        (err) => { }
      );
  }

  getCustomerObj(cust) {
    this.customerService.currentCustomer = cust;
    this.loadDialog = false;
  }

  accordionOpen(i) {
    this.expandedItem = i;
  }

  customerClick(customerId) {
    this.loadWorkorder = true;
    this.customerService.getCustomerById(customerId)
      .subscribe((cust: Customer[]) => {
        this.navigateToCustomer(cust);
      });
    return false;
  }

  navigateToCustomer(cust) {
    const tempcust: Customer = new Customer();
    tempcust.setUpFromWS(cust);
    this.customerService.currentCustomer = tempcust;
    this.customerService.storedCustomers(tempcust);
    this.loadWorkorder = false;
    this.router.navigate(["/detail"]);
  }

  onDeleteAppliance(additionalInfo, workorderID) {
    let controlDeviceId = "";
    let drcontrolId = "";
    let self = this;
    additionalInfo.forEach((element) => {
      if (element.Id == "controlleddevice_id") {
        controlDeviceId = element.Value;
      }
      if (element.Id == "drcontrol_id") {
        drcontrolId = element.Value;
      }
    });

    let additionalInfoBody = {
      ControlledDeviceId: controlDeviceId,
      DrControlId: drcontrolId,
    };

    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(() => {
      this.confirmDelete(workorderID, additionalInfoBody);
    });
  }

  confirmDelete(workorderID, additionalInfoBody) {
    let self = this;
    this.workorderService
      .deleteWorkorderDR(workorderID, additionalInfoBody)
      .subscribe(
        (res) => {
          Swal.fire({
            text: "Appliance deleted successfully",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            self.dialog.closeAll();
            this.workorderService
              .getBBCSWorkorderDetail(
                this.workorderID,
                this.group,
                this.subgroup,
                this.customerService.currentCustomer.Id,
                this.subGroup1
              )
              .subscribe((res) => {
                this.response = res;
              });
          });
        },
        (err) => {
          Swal.fire({
            text: "Appliance could not be deleted",
            icon: "error",
            confirmButtonText: "OK",
          }).then(() => {
            self.dialog.closeAll();
            this.workorderService
              .getBBCSWorkorderDetail(
                this.workorderID,
                this.group,
                this.subgroup,
                this.customerService.currentCustomer.Id,
                this.subGroup1
              )
              .subscribe((res) => {
                this.response = res;
              });
          });
        }
      );
  }

  onSave(resp, measureResponse = null) {
    if (!this.isChildCompoCalled && measureResponse == null) {
      measureResponse = JSON.parse(localStorage.getItem("mData"));
      this.isChildCompoCalled = true;
    }
    resp["MeasureSectionInfo"] = [];
    resp.MeasureSectionInfo?.push(measureResponse);

    resp["SnuggProMeasuresSection"] = [];
    resp.SnuggProMeasuresSection = this.snuggProMeasuresSection ? this.snuggProMeasuresSection : [];

    this.spinner.show();
    this.datepickerWork(resp, true);
    this.disableMainSave = true;
    let selUtilPId = localStorage.getItem("selectedUtilPId");
    if (selUtilPId == "PSG1") {
      let copyResp = resp;
      copyResp.SectionInfo.forEach((element) => {
        if (element.IsSectionModified == "true") {
          element.Tabular.forEach((item) => {
            delete item.newIndex;
          });
        }
      });
      // Todo Common save for both measures and sections is present
      this.workorderService
        .saveWorkorder(
          copyResp,
          copyResp.WorkorderId,
          this.subgroup,
          this.subGroup1
        )
        .subscribe(
          (res) => {
            this.disableMainSave = false;
            if (!res.Message) {
              this.spinner.hide();
              this.snuggProMeasuresSection = [];
              Swal.fire({
                text: "Successfully Saved",
                icon: "success",
                confirmButtonText: "OK",
              }).then(() => {
                this.dialog.closeAll();
                this.loadDRWorkorder();
                this.loadDynamicMenu();
              });
            } else {
              this.spinner.hide();
              Swal.fire({
                text: res.Message,
                icon: "error",
                confirmButtonText: "OK",
              });
            }
          },
          (err) => {
            this.disableMainSave = false;
            this.spinner.hide();
            Swal.fire({
              text: "Error saving workorder",
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        );
    } else {
      if (this.sectionEdited) {
        this.sectionObj.forEach((element) => {
          if (
            resp.SectionInfo[element.sectionId].IsSectionModified == "false"
          ) {
            resp.SectionInfo[element.sectionId].IsSectionModified = "true";
          }
          if (element.rowId != undefined || element.rowId != null) {
            if (
              resp.SectionInfo[element.sectionId].DetailedInfo[element.rowId]
                .IsRowModified == "false"
            ) {
              resp.SectionInfo[element.sectionId].DetailedInfo[
                element.rowId
              ].IsRowModified = "true";
            }
          }
        });
      }

      let copy = JSON.parse(JSON.stringify(resp));
      // let copy = structuredClone(resp);
  this.serializeMultiSelectAttributes(copy);
      copy.SectionInfo.forEach((element) => {
        if (element.DetailedInfo) {
          element.DetailedInfo.forEach((dElement) => {
            dElement.Attributes.forEach((aElement) => {
              if (aElement.Values) {
                aElement.Values = [];
              }
              if (aElement.DataType == 'Bit') {
                aElement.SelectedValue = (aElement.SelectedValue == true) ? 1 : 0;
              }
            });
          });
        }
      });

      this.workorderService.saveWorkorder(copy, resp.WorkorderId, this.subgroup, this.subGroup1)
        .subscribe((res) => {
          let applianceError = "";
          let accountError = "";
          let matIcon = "";
          this.disableMainSave = false;

          if (this.subgroup == "AUDIT") {
            const msg = res.Message;
            if (msg.indexOf("Confirm") != -1) {
              this.spinner.hide();
              const wrapper = document.createElement("div");
              wrapper.innerHTML = res.Message;
              Swal.fire({
                title: "Workorder Status Change",
                html: wrapper,
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
              })
                .then((result) => {
                  this.dialog.closeAll();
                  if (result.value) {
                    this.workorderService.changeWorkorderStatus(resp.WorkorderId, this.subgroup)
                      .subscribe((res) => {
                        if (res?.Action) {
                          Swal.fire(res.Message);
                        } else {
                          this.loadDRWorkorder();
                          this.closeMeasureEditor();
                        }
                      });
                  } else {
                    this.loadDRWorkorder();
                    this.loadDynamicMenu();
                    this.closeMeasureEditor();
                  }
                });
            } else {
              this.spinner.hide();
              Swal.fire({
                text: res.Message,
                icon: "success",
                timer: 3000,
                showConfirmButton: false,
              }).then(() => {
                this.dialog.closeAll();
                this.loadDRWorkorder();
                this.loadDynamicMenu();
                this.closeMeasureEditor();
              });
            }
          } else {
            if (this.subgroup == "INSTALL") {
              if (res.SaveApplianceInfoError) {
                applianceError = res.SaveApplianceInfoErrorMsg;
                matIcon = "<i class='fa fa-close'></i>";
              } else if (!res.SaveApplianceInfoError) {
                applianceError = "Appliance Info";
                matIcon = "<i class='fa fa-check'></i>";
              }
              if (res.SaveAccountInfoError) {
                matIcon = "<i class='fa fa-close'></i>";
                accountError = res.SaveAccountInfoErrorMsg;
              } else if (!res.SaveAccountInfoError) {
                matIcon = "<i class='fa fa-check'></i>";
                accountError = "Account Info";
              }

              const wrapper = document.createElement("div");
              wrapper.innerHTML =
                accountError + matIcon + applianceError + matIcon;
              this.spinner.hide();
              Swal.fire({
                title: "DR Save Status",
                html: wrapper,
                confirmButtonText: "OK",
              }).then(() => {
                this.dialog.closeAll();
                this.loadDRWorkorder();
                this.loadDynamicMenu();
              });
            } else if (this.subgroup == "QA") {
              const wrapper = document.createElement("div");
              wrapper.innerHTML = res.Message;

              if (res.Action) {
                const msg = res.Message;
                if (msg.indexOf("Confirm") != -1) {
                  // its a confirmation to change the status of workorder
                  this.spinner.hide();
                  Swal.fire({
                    title: "Save Workorder",
                    html: wrapper,
                    confirmButtonText: "Yes",
                    cancelButtonText: "No",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                  }).then((result) => {
                    this.dialog.closeAll();

                    if (result.value) {
                      this.workorderService
                        .changeWorkorderStatus(resp.WorkorderId, this.subgroup)
                        .subscribe((res) => {
                          if (res.Action) {
                            Swal.fire(res.Message);
                          } else {
                            this.loadDRWorkorder();
                          }
                        });
                    } else {
                      this.loadDRWorkorder();
                    }
                  });
                } else {
                  wrapper.innerHTML = res.Message;
                  this.spinner.hide();
                  this.disableMainSave = false;
                  Swal.fire({
                    title: "Save Workorder",
                    html: wrapper,
                    confirmButtonText: "OK",
                  }).then(() => {
                    this.dialog.closeAll();
                    this.loadDRWorkorder();
                  });
                }
              }
            } else {
              if (res.Action) {
                const qaQcmsg = res.Message;
                if (
                  qaQcmsg.indexOf("READY") != -1 ||
                  qaQcmsg.indexOf("Ready") != -1
                ) {
                  this.spinner.hide();
                  Swal.fire({
                    title: "Approve Status Change",
                    text: res.Message,
                    confirmButtonText: "Yes",
                    cancelButtonText: "No",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                  }).then((result) => {
                    this.dialog.closeAll();
                    if (result.value) {
                      this.spinner.hide();
                      this.workorderService
                        .changeWorkorderStatus(resp.WorkorderId, this.subgroup)
                        .subscribe((res) => {
                          if (res.Action) {
                            Swal.fire(res.Message);
                          } else {
                            this.loadDRWorkorder();
                            this.closeMeasureEditor();
                          }
                        });
                    } else {
                      this.loadDRWorkorder();
                      this.closeMeasureEditor();
                    }
                  });
                } else {
                  this.spinner.hide();
                  Swal.fire({
                    title: res.Message,
                    icon: "info",
                    confirmButtonText: "OK",
                  });
                }
              } else {
                if (!res.Action) {
                  this.spinner.hide();
                  this.measuresLength = 0;
                  Swal.fire({
                    text: res.Message,
                    icon: "success",
                    timer: 3000,
                    showConfirmButton: false,
                  }).then(() => {
                    this.dialog.closeAll();
                    this.loadDRWorkorder();
                    this.loadDynamicMenu();
                  });
                } else {
                  this.spinner.hide();
                  Swal.fire({
                    title: res.Message,
                    icon: "info",
                    confirmButtonText: "OK",
                  });
                }
              }
            }
          }
        });
    }
    this.isChildCompoCalled = false;
  }

  /**
   * Process save data without triggering page refresh.
   * Used for import workflows where refresh should only happen after all APIs complete.
   * @param resp - The response object with workorder data
   * @param measureResponse - Optional measure response data
   */
  processSaveData(resp: any, measureResponse = null): Promise<void> {
    if (!this.isChildCompoCalled && measureResponse == null) {
      measureResponse = JSON.parse(localStorage.getItem("mData"));
      this.isChildCompoCalled = true;
    }
    resp["MeasureSectionInfo"] = [];
    resp.MeasureSectionInfo?.push(measureResponse);

    resp["SnuggProMeasuresSection"] = [];
    resp.SnuggProMeasuresSection = this.snuggProMeasuresSection ? this.snuggProMeasuresSection : [];

    this.spinner.show();
    this.datepickerWork(resp, true);
    this.disableMainSave = true;
    let selUtilPId = localStorage.getItem("selectedUtilPId");
    
    if (selUtilPId == "PSG1") {
      let copyResp = resp;
      copyResp.SectionInfo.forEach((element) => {
        if (element.IsSectionModified == "true") {
          element.Tabular.forEach((item) => {
            delete item.newIndex;
          });
        }
      });
      return new Promise<void>((resolve, reject) => {
        this.workorderService
          .saveWorkorder(
            copyResp,
            copyResp.WorkorderId,
            this.subgroup,
            this.subGroup1
          )
          .subscribe(
            () => {
              this.disableMainSave = false;
              this.spinner.hide();
              this.snuggProMeasuresSection = [];
              // Note: No refresh calls here - parent dialog will handle refresh after all APIs complete
              this.isChildCompoCalled = false;
              resolve();
            },
            (err) => {
              this.disableMainSave = false;
              this.spinner.hide();
              this.isChildCompoCalled = false;
              console.error("Error saving workorder", err);
              reject(err);
            }
          );
      });
    } else {
      if (this.sectionEdited) {
        this.sectionObj.forEach((element) => {
          if (
            resp.SectionInfo[element.sectionId].IsSectionModified == "false"
          ) {
            resp.SectionInfo[element.sectionId].IsSectionModified = "true";
          }
          if (element.rowId != undefined || element.rowId != null) {
            if (
              resp.SectionInfo[element.sectionId].DetailedInfo[element.rowId]
                .IsRowModified == "false"
            ) {
              resp.SectionInfo[element.sectionId].DetailedInfo[
                element.rowId
              ].IsRowModified = "true";
            }
          }
        });
      }

      let copy = JSON.parse(JSON.stringify(resp));
  this.serializeMultiSelectAttributes(copy);
      copy.SectionInfo.forEach((element) => {
        if (element.DetailedInfo) {
          element.DetailedInfo.forEach((dElement) => {
            dElement.Attributes.forEach((aElement) => {
              if (aElement.Values) {
                aElement.Values = [];
              }
              if (aElement.DataType == 'Bit') {
                aElement.SelectedValue = (aElement.SelectedValue == true) ? 1 : 0;
              }
            });
          });
        }
      });

      return new Promise<void>((resolve, reject) => {
        this.workorderService.saveWorkorder(copy, resp.WorkorderId, this.subgroup, this.subGroup1)
          .subscribe(() => {
            this.disableMainSave = false;
            this.spinner.hide();
            // Note: No refresh calls here - parent dialog will handle refresh after all APIs complete
            this.isChildCompoCalled = false;
            resolve();
          },
          (err) => {
            this.disableMainSave = false;
            this.spinner.hide();
            this.isChildCompoCalled = false;
            console.error("Error saving workorder", err);
            reject(err);
          });
      });
    }
  }

  addCustomWorkorder(workorderId, menuName) {
    this.workorderService.addCustomWorkorderAction(workorderId, menuName).subscribe((res) => {
      if ((res.WorkorderId != null || res.WorkorderId != "") && (res.Method === 'OPEN')) {
        Swal.fire({
          text: res.Message + ". Do you want to open the workorder?",
          icon: "warning",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
        }).then((result) => {
          if (result.value) {
            this.loadWorkorder = true;
            this.workorderID = res.WorkorderId;
            this.workorderService
              .getBBCSWorkorderDetail(
                res.WorkorderId,
                res.Group,
                res.SubGroup,
                "unknown",
                res.SubGroup1
              )
              .subscribe((res) => {
                this.response = res;
                this.loadWorkorder = false;
              });
            this.handleEnrollmentWorkorderClick(res);
          }
        });
      } else {
        Swal.fire({
          text: res.Message,
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          this.dialog.closeAll();
          this.loadDRWorkorder();
          this.closeMeasureEditor();
        });
      }
    },
      (err) => {
        Swal.fire({
          text: "Error while creating workorder",
          icon: "error",
          confirmButtonText: "OK",
        });
      })
  }

  handleEnrollmentWorkorderClick(data) {
    this.workorderService.currentWorkorderID = data.WorkorderId;
    this.enrollmentService.currentEnrollmentID = data.EnrollmentId;
    this.router.navigate(['workorderGetSave', data.Group, data.SubGroup, data.WorkorderId, data?.SubGroup1 ?? "ALL"]);
  }

  navigateToWorkOrder(workOrder: WorkOrder): void {
    if (!workOrder.displayLinkStyle) {
      return;
    }

    workOrder.workOrderId ??= '';

    if (workOrder.group == null || workOrder.group == '') {
      workOrder.group = 'DEFAULT';
    }

    workOrder.subgroup ??= '';

    if (workOrder.subgroup1 == null || workOrder.subgroup1 == '') {
      workOrder.subgroup1 = 'ALL';
    }

    let url = '/workorderGetSave';
    if (workOrder.group !== '') {
      url += `/${workOrder.group}`;
    }

    if (workOrder.subgroup !== '') {
      url += `/${workOrder.subgroup}`;
    }

    if (workOrder.workOrderId !== '') {
      url += `/${workOrder.workOrderId}`;
    }

    if (workOrder.subgroup1 !== '') {
      url += `/${workOrder.subgroup1}`;
    }

    this.workorderService.currentWorkorderID = workOrder.workOrderId;
    this.router.navigate([url]);
  }

  addInspectionWorkorder() {
    this.workorderService.addInspectionWorkorder(this.workorderID).subscribe(
      (res) => {
        if (
          (res.WorkorderId != null || res.WorkorderId != "") &&
          this.subgroup != "PREQUALIFY"
        ) {
          Swal.fire({
            text: res.Message + ". Do you want to open the workorder?",
            icon: "warning",
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          }).then((result) => {
            if (result.value) {
              this.workorderID = res.WorkorderId;
              this.group = res.Group;
              this.subgroup = res.SubGroup;
              this.subGroup1 = res.SubGroup1;
              this.workorderService.currentWorkorderID = res.WorkorderId;
              this.router.navigate(['workorderGetSave', this.group, this.subgroup, this.workorderID, this.subGroup1 ?? "ALL"]);
            } else {
              this.loadDRWorkorder();
            }
          });
        } else {
          Swal.fire({
            text: res.Message,
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            this.dialog.closeAll();
            this.loadDRWorkorder();
            this.closeMeasureEditor();
          });
        }
      },
      () => {
        Swal.fire({
          text: "Error creating inspection workorder",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    );
  }

  getWorkOrders(workorderID: string) {
    this.dialog.open(WorkorderStatusDialogComponent, {
      data: {
        workorderID: workorderID,
        panelClass: localStorage.getItem("themeName"),
      },
      disableClose: true,
      width: '150vh'
    });
  }

  // add interaction code
  onLoad() {
    /*  this.ifSave=true; */
    this.timerInterval = this.timersource.subscribe(() =>
      this.interactionTimer()
    );
    this.types = [];
    this.whys = [];
    this.reasons = [];
    this.populateTypeDropdown();
    this.populateMarketingDropdown();
    this.selectedMarketing = "";
    this.notesInput = "";
    this.isCompleteChecked = true;
    if (!this.isCompleteChecked) {
      this.checkIfComplete = false;
    }
    this.checkIfComplete = false;
    this.customerId = this.customerService.currentCustomer.Id;
    this.programSponsorId = this.utilityService.currentUtility.ProgramsponsorId;
    this.officeId = this.utilityService.currentUtility.OfficeId;
    this.startTime = new Date();
    // this.timerInterval = this.timersource.subscribe(() => this.interactionTimer());
    this.adding = false;
    if (this.completeCheckbox) {
      this.completeCheckbox.checked = true;
    }
  }

  onCompleteClick(event) {
    if (event.checked) {
      this.isCompleteChecked = true;
      this.checkIfComplete = true;
      this.selectedReason = "";
      this.completeCheckbox.checked = true;
    } else {
      this.isCompleteChecked = false;
      this.checkIfComplete = false;

      if (
        this.selectedTypeCode != null ||
        this.selectedTypeCode != undefined ||
        this.selectedTypeCode != ""
      ) {
        this.populateReasonDropdown();
      }
      this.completeCheckbox.checked = false;
    }
  }

  private interactionTimer() {
    this.timerMinutes = 0;
    this.timerSeconds = 0;
    const elapsed = (new Date().getTime() - this.startTime.getTime()) / 1000; // secs
    const sec = elapsed % 60;
    const min = Math.floor(elapsed / 60);
    this.timerMinutes = min;
    this.timerSeconds = sec;
    this.timer =
      this.timerMinutes +
      ":" +
      (this.timerSeconds < 10 ? "0" : "") +
      this.timerSeconds.toFixed(0);
  }

  private populateTypeDropdown() {
    this.types = [];
    this.interactionService.getInteractionType().subscribe(
      (res) => {
        if (
          res.InteractionTypes != null &&
          Array.isArray(res.InteractionTypes)
        ) {
          res.InteractionTypes.forEach((element) => {
            this.types.push({
              id: element["Name"],
              value: element["Description"],
            });
          });

          this.selectedTypeCode = this.types[0];
          this.changeType(this.selectedTypeCode);
        }
      },
      (err) => {
        Swal.fire({
          text: err,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    );
  }

  checkGoodDropForm(): boolean {
    if (
      this.selectedTypeCode === undefined ||
      this.selectedTypeCode.value === "General Query" ||
      this.selectedWhy === undefined ||
      (!this.isCompleteChecked &&
        (this.selectedReason === undefined || this.selectedReason === ""))
    ) {
      return true;
    } else {
      return false;
    }
  }

  addInteraction() {
    this.adding = true;
    this.customerId = this.customerService.currentCustomer.Id;
    try {
      // start date and end date same
      const doneDate = moment();
      const formattedDoneDate = doneDate.toJSON();

      const endDate = moment();
      const formattedEndDate = endDate.toJSON();

      const startDate = doneDate;
      startDate.subtract(this.timerMinutes, "minutes");
      startDate.subtract(this.timerSeconds, "seconds");
      const formattedStartDate = startDate.toJSON();

      this.savedInteraction.CustomerId =
        this.customerId === null ? "" : this.customerId;
      if (this.selectedMarketing != undefined) {
        this.savedInteraction.MarketingCode =
          this.selectedMarketing.id == null ? "" : this.selectedMarketing.id;
        this.savedInteraction.MarketingDescription =
          this.selectedMarketing.value == null
            ? ""
            : this.selectedMarketing.value;
      }

      this.savedInteraction.Notes =
        this.notesInput === null ? "" : this.notesInput;
      if (this.selectedReason != undefined) {
        this.savedInteraction.ReasonCode =
          this.selectedReason.id === null ? "" : this.selectedReason.id;
        this.savedInteraction.ReasonDescription =
          this.selectedReason.value === null ? "" : this.selectedReason.value;
      }
      if (this.selectedWhy != undefined) {
        this.savedInteraction.WhyCode =
          this.selectedWhy.id === null ? "" : this.selectedWhy.id;
        this.savedInteraction.WhyDescription =
          this.selectedWhy.value === null ? "" : this.selectedWhy.value;
      }
      this.savedInteraction.TypeCode =
        this.selectedTypeCode.id === null ? "" : this.selectedTypeCode.id;
      this.savedInteraction.TypeDescription =
        this.selectedTypeCode.value === null ? "" : this.selectedTypeCode.value;
      this.savedInteraction.IsComplete =
        this.isCompleteChecked === false ? false : this.isCompleteChecked;
      if (this.utilityService.currentProgramSponsor.SourceId === "BBCS") {
        this.savedInteraction.User =
          this.utilityService.currentUtility.BBCSUserId === null
            ? ""
            : this.utilityService.currentUtility.BBCSUserId;
      } else {
        this.savedInteraction.User =
          localStorage.getItem("loggedInUserName") === null
            ? ""
            : localStorage.getItem("loggedInUserName");
      }

      this.savedInteraction.StartDate = new Date(formattedStartDate).toJSON();
      this.savedInteraction.EndDate = new Date(formattedEndDate).toJSON();
      this.savedInteraction.DoneDate = new Date(formattedDoneDate).toJSON();
      this.savedInteraction.WorkorderId =
        this.workorderService.currentWorkorderID == null ||
          this.workorderService.currentWorkorderID == undefined
          ? null
          : this.workorderService.currentWorkorderID;
      this.savedInteraction.EnrollmentId =
        this.enrollmentService.currentEnrollmentID == null ||
          this.enrollmentService.currentEnrollmentID == undefined
          ? null
          : this.enrollmentService.currentEnrollmentID;

      this.savedInteraction.ProgramSponsorId =
        this.programSponsorId === null ? "" : this.programSponsorId;
      if (this.savedInteraction != null) {
        this.ifSave = false;
        this.interactionService
          .addInteractions(this.savedInteraction)
          .subscribe(
            (res) => {
              try {
                this.ifSave = true;
                this.loadTable = false;
                this.showAddInteractions = false;
                this.timerInterval.unsubscribe();
                //this.initfunc();
                this.loadDRWorkorder();
                this.loadDynamicMenu();
                Swal.fire({
                  text: "Saved Successfully!",
                  icon: "success",
                  confirmButtonText: "OK",
                }).then((result) => {
                  this.dialog.closeAll();
                  if (result.value) {
                    this.onLoad();
                  }
                });
              } catch {
                Swal.fire({
                  text: "Server side error! Please try again",
                  icon: "error",
                  confirmButtonText: "OK",
                }).then((result) => {
                  this.dialog.closeAll();
                  if (result.value) {
                    this.onLoad();
                  }
                });
              }
            },
            (err) => {
              this.dialog.closeAll();
              Swal.fire({
                text: err,
                icon: "error",
                confirmButtonText: "OK",
              });
            }
          );
      }
    } catch {
      Swal.fire({
        text: "Please check the entered data",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  }

  addInteractionClose() {
    this.showAddInteractions = false;
    // this.timerInterval.unsubscribe();
    this.loadTable = false;
    this.workorderService
      .getBBCSWorkorderDetail(
        this.workorderID,
        this.group,
        this.subgroup,
        this.customerService.currentCustomer.Id,
        this.subGroup1
      )
      .subscribe((res) => {
        this.response = res;
        this.loadTable = false;
      });
  }

  changeType(value) {
    if (value != null && value !== "") {
      this.whys = [];
      this.selectedWhy = undefined;
      this.reasons = [];
      this.populateWhyDropdown();
      if (this.checkIfComplete === false) {
        this.populateReasonDropdown();
      }
    }
  }

  private populateWhyDropdown() {
    this.whys = [];
    this.interactionService
      .getInteractionWhys(this.selectedTypeCode.id)
      .subscribe(
        (res) => {
          if (
            res.InteractionWhys != null &&
            Array.isArray(res.InteractionWhys)
          ) {
            res.InteractionWhys.forEach((element) => {
              this.whys.push({
                id: element["Name"],
                value: element["Description"],
              });
            });
          }
        },
        (err) => {
          Swal.fire({
            text: err,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      );
  }

  private populateReasonDropdown() {
    this.reasons = [];
    this.interactionService
      .getInteractionReasons(this.selectedTypeCode.id)
      .subscribe(
        (res) => {
          if (
            res.InteractionReasons != null &&
            Array.isArray(res.InteractionReasons)
          ) {
            res.InteractionReasons.forEach((element) => {
              this.reasons.push({
                id: element["Name"],
                value: element["Description"],
              });
            });
          }
        },
        (err) => {
          Swal.fire({
            text: err,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      );
  }

  private populateMarketingDropdown() {
    this.marketing = [];
    this.interactionService.getInteractionMarketing().subscribe(
      (res) => {
        if (
          res.InteractionMarketing != null &&
          Array.isArray(res.InteractionMarketing)
        ) {
          res.InteractionMarketing.forEach((element) => {
            this.marketing.push({
              id: element["Name"],
              value: element["Description"],
            });
          });
        }
      },
      (err) => {
        Swal.fire({
          text: err,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    );
  }

  //------------------Measures----------------------
  openAddMeasure(toggleAddMeasure, index, Lineitemmasterid) {
    this.existingFixtureArray = [];
    this.energyStarModelArray = [];
    this.manufacturerArray = [];
    this.modelhvacArray = [];
    this.expandedItem = index;
    this.loadDialog = true;
    this.showAddMeasures = toggleAddMeasure;
    if (this.showAddMeasures == true && Lineitemmasterid != null) {
      this.addMeasures(Lineitemmasterid);
    }
  }

  addMeasures(Lineitemmasterid) {
    this.spinner.show();
    this.measureResponse = [];
    this.measuresLength = 0;
    this.selectedMeasureType = Lineitemmasterid;
    this.workorderService
      .addMeasures(
        this.workorderID,
        "addMeasure",
        localStorage.getItem("subGroup"),
        "ALL",
        Lineitemmasterid ?? "ALL",
        localStorage.getItem("subGroup1")
      )
      .subscribe(
        (res: any) => {
          this.measuresLength = res?.DetailedInfo[0]?.Attributes?.length;
          this.lineItemId = res?.DetailedInfo[0]?.Attributes[0]?.SelectedValue;
          this.measureResponse = res;
          this.parseDatePicker(res);
          res?.DetailedInfo[0]?.Attributes.forEach(element => {
            if (element.AttributeId == 'repltype_' + this.utilityService.currentUtility.OfficeId.toLowerCase() && element.Name == "New Fixture Type") {
              this.measureData = element.Values;
              this.filterNewFixture = element.Values;
            }
            if (element.AttributeId == 'test_eq_serialno_' + this.utilityService.currentUtility.OfficeId.toLowerCase()) {
              this.measureData = element.Values;
              this.esmodelArray = element.Values;
            }
            if (element.AttributeId == 'replmanufhvac_' + this.utilityService.currentUtility.OfficeId.toLowerCase()) {
              this.measureData = element.Values;
              this.manufacturerhvacArray = element.Values;
            }
          });
          this.spinner.hide();
        },

        () => {
          const err = "Error in Adding Measures";
        }
      );
  }

  parseDatePicker(res: any) {
    res.DetailedInfo[0].Attributes.forEach((attr: any) => {
      if (attr.DataType === 'Date' && attr.SelectedValue) {
        const parsed = new Date(attr.SelectedValue);
        if (isNaN(parsed.getTime())) {
          const [day, monthStr, yearShort] = attr.SelectedValue.split('-');
          const months = { Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5, Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11 };
          const month = months[monthStr];
          const year = 2000 + Number(yearShort);
          attr.SelectedValue = new Date(year, month, +day);
        } else {
          attr.SelectedValue = parsed;
        }
      }
    });
  }
  //------------------ End of Measures----------------------

  // --------------- Report Handling -----------------------

  doReport(repInfo) {
    if (repInfo.PROGRAM_ID && repInfo.PROGRAM_ID.Value) {
      if (repInfo.PROGRAM_ID.Value.startsWith("DOM1") && repInfo.PROGRAM_ID.Value.endsWith("ICV")) {
        // Initial Assessment
        this.doReportDOMInit(repInfo);
      }
      else if (repInfo.PROGRAM_ID.Value.startsWith("DOM1") && repInfo.PROGRAM_ID.Value.endsWith("CHV")) {
        // Comprehensive Assessment
        this.doReportDOMComp(repInfo);
      }
    } else if (1) {
      this.doReportFEMD(repInfo);
    }
  }

  async doReportDOMInit(repInfo) {
    // Dominion Initial 
    console.log('>>>> in doReportDOMInit');
    let emailReport = this.response.EmailReport;

    const reportInstance = new DomInitialReport(this.http);

    let blob = await reportInstance.doDoc(repInfo);

    this.uploadReportBlob(this.response.WorkorderId, emailReport, (this.userService.dbBBCSId ? this.userService.dbBBCSId : this.utilityService.currentUtility.BBCSUserId), blob);
  }

  async doReportDOMComp(repInfo) {
    // Dominion Comprehensive
    console.log('>>>> in doReportDOMComp');
    let emailReport = this.response.EmailReport;

    const reportInstance = new DomComprehensiveReport(this.http);

    let blob = await reportInstance.doDoc(repInfo);

    this.uploadReportBlob(this.response.WorkorderId, emailReport, (this.userService.dbBBCSId ? this.userService.dbBBCSId : this.utilityService.currentUtility.BBCSUserId), blob);
  }

  doReportFEMD(repInfo) {
    console.log('>>>> in doReportFEMD');
    // console.log(this.response.SectionInfo[2].DetailedInfo[0].Attributes[28]);
    let repPref = this.response.SectionInfo.find(field => field["SectionName"] === "ASSESSMENT QUESTIONNAIRE");
    if (repPref == undefined || repPref == '' || repPref == null) {
      console.log("Report options not defined");
      return;
    }

    let repPrefIndex = repPref.DetailedInfo[0].Attributes.find(val => val.Name == "Report Preference");
    if (repPrefIndex < 0) {
      console.log("Report options not available");
      return;
    }

    // console.log(">>2 = " + repPrefIndex);
    // console.log(repPrefIndex);

    if (repPrefIndex.SelectedValue == undefined || repPrefIndex.SelectedValue == '' || repPrefIndex.SelectedValue == null) {
      console.log("Report selected options not defined");
      return;
    }

    // let repPrefValue = this.response.Values.find(field => field["Id"] == repPrefIndex.SelectedValue);
    // console.log(">>3 = " + repPrefValue);
    // console.log(repPrefValue);
    // if (repPrefValue == 'Decline report ') {
    if (repPrefIndex.SelectedValue == "FEE6QDR") {
      console.log("Report declined");
      return;
    }

    let emailReport = 0;
    if (repPrefIndex.SelectedValue == "FEE6QE") {
      emailReport = 1;
    }

    const reportInstance = new QhecReport();

    let blob = reportInstance.doDoc(repInfo);
    this.uploadReportBlob(this.response.WorkorderId, emailReport, (this.userService.dbBBCSId ? this.userService.dbBBCSId : this.utilityService.currentUtility.BBCSUserId), blob);
  }

  uploadReportBlob(workorderId, emailReport, bbcsUser, repBlob) {
    let fileReader = new FileReader();
    fileReader.onload = (e) => {
      let data = fileReader.result;

      let fileName = this.utilityService.currentUtility.OfficeId + "_" + workorderId + ".pdf";
      let body = {
        "File": fileName,
        "ImageCode": 'AUDREPORT',
        "User": bbcsUser,
        "EmailReport": emailReport,
        "Content": data.slice(28)
      };

      this.workorderService.uploadFile(fileName, body, workorderId).subscribe((res: any) => {
        // console.log(res);
        if (res.Success) {
          // not a critical error because report will be marked for generation each time a complete QHEC wo is viewed
          // if the report does not exist
          console.log(">>>>>>> upload good");
        } else {
          console.log(">>>>>>> upload bad");
          console.log(res);
        }
      });
    };

    fileReader.readAsDataURL(repBlob);
  }

  //-----------------Date picker implementation------------
  // datepickerWork(resp: any, isSave: boolean) {
  //   const sections = resp?.SectionInfo || [];
  //   resp.MeasureSectionInfo.forEach(major => {
  //     major.DetailedInfo.forEach(attr => {
  //       attr.Attributes.forEach(ele => {
  //         if (ele.DataType === 'Date' && ele.SelectedValue) {
  //           if (isSave) {
  //           attr.SelectedValue = this.toUtcMidnightISO(attr.SelectedValue);
  //           } else {
  //             attr.SelectedValue = this.fromServerDateToLocalMidnight(attr.SelectedValue);
  //           }
  //         }
  //       });
  //     });
  //   });
  //   sections.forEach(section => {
  //     const attributes = section?.DetailedInfo?.[0]?.Attributes || [];
  //     attributes.forEach(attr => {
  //       if (attr.DataType === 'Date' && attr.SelectedValue) {
  //         if (isSave) {
  //           attr.SelectedValue = this.toUtcMidnightISO(attr.SelectedValue);
  //         } else {
  //           attr.SelectedValue = this.fromServerDateToLocalMidnight(attr.SelectedValue);
  //         }
  //       }
  //     });
  //   });
  // }

  datepickerWork(resp: any, isSave: boolean) {
    const transformDate = (item: any) => {
      if (item.DataType === 'Date' && item.SelectedValue) {
        item.SelectedValue = isSave
          ? this.toUtcMidnightISO(item.SelectedValue)
          : this.fromServerDateToLocalMidnight(item.SelectedValue);
      }
    };

    // MeasureSectionInfo path
    resp?.MeasureSectionInfo?.forEach(major => {
      major?.DetailedInfo?.forEach(attr => {
        attr?.Attributes?.forEach(transformDate);
      });
    });

    // SectionInfo path
    resp?.SectionInfo?.forEach(section => {
      const attributes = section?.DetailedInfo?.[0]?.Attributes || [];
      attributes.forEach(transformDate);
    });
  }

  private toUtcMidnightISO(dateLike: any): string {
    const d = (dateLike instanceof Date) ? dateLike : new Date(dateLike);
    const utc = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    return utc.toISOString();
  }

  private fromServerDateToLocalMidnight(isoLike: string | Date): Date {
    const d = (isoLike instanceof Date) ? isoLike : new Date(isoLike);
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }
  // datepickerWork(resp, isAdd) {
  //   const sections = resp?.SectionInfo || [];
  //   sections.forEach(section => {
  //     const attributes = section?.DetailedInfo?.[0]?.Attributes || [];

  //     attributes.forEach(attr => {
  //       if (attr.DataType === 'Date') {
  //         if (attr.SelectedValue) {
  //           if (isAdd) {
  //             if (
  //               attr.SelectedValue != null ||
  //               attr.SelectedValue != undefined
  //             ) {
  //               let dt = moment(attr.SelectedValue).toLocaleString();
  //               // console.log("Date " + dt)
  //               if (dt.indexOf("0530") != -1) {
  //                 attr.SelectedValue = moment(dt).add(1, "day").toDate();
  //                 // console.log("if block");
  //               } else {
  //                 attr.SelectedValue = moment(dt).toDate();
  //                 // console.log("else block");
  //               }
  //             }
  //           } else {
  //             if (
  //               attr.SelectedValue != null ||
  //               attr.SelectedValue != undefined
  //             ) {
  //               this.inputReadOnly = !this.inputReadOnly;
  //               attr.SelectedValue = new Date(attr.SelectedValue);
  //             }
  //           }
  //         }
  //       }
  //     });
  //   });
  // }

  dateChange(e) {
    this.minDateToFinish.next(e.value.toString());
  }
  //-----------------End of Date picker implementation------------

  //------------------Testing-----------------------

  clearYearBuilt($event): void {
    this.term = "";
  }

  onChangePayee(eve) {
    let pOptionName = "OWNER";
    if (eve.value == pOptionName) {
      this.isDisabled = true;
      this.fetchData(true);
    }
    if (eve.value != pOptionName) {
      this.isDisabled = false;
      this.fetchData(false);
    }
  }

  fetchData(isDisabled) {
    if (isDisabled) {
      this.response?.SectionInfo[3]?.DetailedInfo[0]?.Attributes.find(
        (payeeElement) => {
          this.response?.SectionInfo[0]?.DetailedInfo[0]?.Attributes.find(
            (customerElement) => {
              (customerElement.Name == "Company Name" ||
                customerElement.Name == "Name") &&
                payeeElement.Name == "Payable To"
                ? (payeeElement.SelectedValue = customerElement.SelectedValue)
                : "";
              customerElement.Name == "Service Address" &&
                payeeElement.Name == "Address"
                ? (payeeElement.SelectedValue = customerElement.SelectedValue)
                : "";
              customerElement.Name == "City" && payeeElement.Name == "City"
                ? (payeeElement.SelectedValue = customerElement.SelectedValue)
                : "";
              customerElement.Name == "State" && payeeElement.Name == "State"
                ? (payeeElement.SelectedValue = customerElement.SelectedValue)
                : "";
              (customerElement.Name == "Zip Code" ||
                customerElement.Name == "Zip") &&
                payeeElement.AttributeId == "pZipcode"
                ? (payeeElement.SelectedValue = customerElement.SelectedValue)
                : "";
              payeeElement.AttributeId == "pAddress2" ? payeeElement.SelectedValue = "" : "";
            }
          );
        }
      );
    }
    if (!isDisabled) {
      this.response?.SectionInfo[3]?.DetailedInfo[0]?.Attributes.forEach(
        (element, i) => {
          if (i > 0) {
            element.SelectedValue = "";
          }
        }
      );
    }
  }

  payeeOnPageLoad() {
    if (
      this.response?.SectionInfo[3]?.DetailedInfo[0]?.Attributes[0]
        ?.SelectedValue == "OWNER"
    ) {
      this.isDisabled = true;
    }
  }

  // Comparison screen

  openComparisonDialog(workOrderResponse) {
    this.spinner.show();
    let className = localStorage.getItem("themeName");
    const dialogRef = this.dialog.open(ComparisonScreenDialogComponent, {
      data: {
        workOrderResponseData: workOrderResponse,
      },
      panelClass: className,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.onSave(result?.data);
      }
    });
  }

  importSalesExcel(response) {
    let className = localStorage.getItem("themeName");
    const dialogRef = this.dialog.open(UploadExcelComponent, {
      data: {
        caption: "Import Report",
        response: response,
        // Pass callback for processing save data without refresh
        onSaveCallback: (resp: any) => this.processSaveData(resp)
      },
      panelClass: className,
      disableClose: true
    });
    
    dialogRef.afterClosed().subscribe((result) => {
      if (result) { 
        this.loadDRWorkorder();
        this.loadDynamicMenu();
      }
    });
  }

  actionWorkorder(WorkorderType: any) {
    let Obj = {
      WorkorderID: this.workorderID,
      StatusCode: WorkorderType == 'Deactivate' ? 920
        : WorkorderType == 'Reject' ? 250
          : 930,
      DialogTitle: WorkorderType == 'Deactivate' ? "Deactivate Workorder"
        : WorkorderType == 'Reject' ? "Reject Workorder"
          : "Cancel Workorder",
      ProgramDetailId: this.response?.ProgramdetailId
    };

    let className = localStorage.getItem("themeName");
    const dialogRef = this.dialog.open(CanceldeactivateDialogComponent, {
      data: {
        dataKey: Obj,
        isCustomUiChange: this.userService.IsCustomUiChange,
        panelClass: className,
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.success) {
        this.loadDRWorkorder();
        this.loadDynamicMenu();
        this.closeMeasureEditor();
      }
    });
  }

  setIncentiveWorkOrders(res): void {
    this.incentiveWorkOrders = [];
    const incentiveWos = res?.['IncentiveWorkorder'];
    if (incentiveWos != null && incentiveWos[0] != null) {
      const incWo = incentiveWos[0];
      let newIncWorkOrder: WorkOrder = {
        workOrderId: incWo.IncWorkorderId,
        group: incWo.IncGroupId,
        subgroup: incWo.IncSubgroupId,
        subgroup1: incWo.IncSubgroupId1,
        displayLinkStyle: false
      };
      newIncWorkOrder.displayLinkStyle = this.isWorkOrderRoutable(newIncWorkOrder);
      this.incentiveWorkOrders.push(newIncWorkOrder);
    }
  }

  setParentWorkOrder(response: object): void {
    const resParentWorkOrder = response?.['ParentWorkorder'];
    if (resParentWorkOrder?.length > 0) {
      if (resParentWorkOrder[0].ParentWorkorderId != null) {
        this.parentWorkOrder = {
          workOrderId: resParentWorkOrder[0].ParentWorkorderId ?? '',
          group: resParentWorkOrder[0].ParentGroupId ?? '',
          subgroup: resParentWorkOrder[0].ParentSubgroupId ?? '',
          subgroup1: resParentWorkOrder[0].ParentSubgroupId1 ?? '',
          stage: resParentWorkOrder[0].Stage ?? 'Audit Work Order:',
          displayLinkStyle: false
        };
        this.parentWorkOrder.displayLinkStyle = this.isWorkOrderRoutable(this.parentWorkOrder);
      }
    }
  }

  setQaWorkOrders(response: object): void {
    this.qaTableDataSource = [];
    const sectionInfo = response?.['SectionInfo'];
    if (sectionInfo) {
      sectionInfo.forEach((section) => {
        if (section.SectionName === 'QA ACTIVITY') {
          section.GridValue.forEach((gridValue) => {
            const qaWorkOrder: QaWorkOrder = {
              workOrderId: gridValue?.['QA Workorder'],
              auditor: gridValue?.['QA Auditor'],
              dateTime: gridValue?.['Date/Time'],
              score: gridValue?.['Score'],
              status: gridValue?.['Status'],
              group: gridValue?.['QAGroupId'],
              subgroup: gridValue?.['QASubgroupId'],
              subgroup1: gridValue?.['QASubgroupId1'],
              displayLinkStyle: false
            };

            qaWorkOrder.displayLinkStyle = this.isWorkOrderRoutable(qaWorkOrder);

            if (qaWorkOrder.workOrderId != null) {
              this.qaTableDataSource.push(qaWorkOrder);
            }
          });
        }
      });
    }
  }

  isWorkOrderRoutable(workOrder: WorkOrder): boolean {
    if (workOrder['subgroup'] != undefined) {
      return true;
    }
    return false;
  }
}
